module.exports = __webpack_public_path__ + "static/img/weixin.f9ec56e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/weixin.png
// module id = zaBc
// module chunks = 19